module.exports = __webpack_public_path__ + "static/media/hero_small.433eba82.jpg";